module.exports = __webpack_public_path__ + "img/instagram_active.af07ac4.png";